import React from 'react'
import { Provider, useSelector } from 'react-redux'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { userRoutes, adminRoutes, userAuthRoutes } from 'modules/routes'
import { createStore } from 'modules/store'
import { Layout } from 'components'
import GoogleAnalytics from './components/GoogleAnalytics'
import './App.scss'

const { store, persistor } = createStore()

const NewRout = () => {
  const { user } = useSelector(({ session }) => session)
  const newRoutes = user?.user?.uuid ? userAuthRoutes : userRoutes
  return (
    user?.user?.isAdmin ? (
      <>
        {adminRoutes.map(route => <Route key={route.path} {...route} />)}
        <Redirect from='/' to='/admin/illustrations' />
      </>
    ) : (
      <Layout>
        {newRoutes.map(route => <Route key={route.path} {...route} />)}
      </Layout>
    )
  )
}

const App = () => (
  <PersistGate loading={null} persistor={persistor}>
    <Provider store={store}>
      <Router>
        <NewRout />

        <GoogleAnalytics />
      </Router>
    </Provider>
  </PersistGate>
)

export default App
